import { UserCoupon } from 'app/domain/coupon/dtos/user-coupon.dto';

export interface User {
  id: string;
  name: string;
  cpf: string;
  birthDate: string;
  email: string;
  phone: string;
  pushToken: string | undefined;
  address: UserAddress[];
  roles: UserRoles[];
  s4eUserId: string;
  hasAppointmentCandidate?: boolean;
  couponProcedures?: UserCoupon[] | [];
}

export enum UserRoles {
  Physician = 'physician',
  Beneficiary = 'beneficiary',
}

export enum UserRolesTranslated {
  Physician = 'Dentista',
  Beneficiary = 'Cliente',
}

export interface UserAddress {
  id: string;
  title: string;
  zipCode: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  complement: string;
  reference: string;
  latitude: number;
  longitude: number;
}
